<div class="bg-primary-main flex min-h-screen w-full flex-col items-center justify-center">
  <div class="flex flex-col items-center justify-center space-y-4 rounded-md bg-white p-8 shadow">
    <img src="assets/{{ logo }}" class="h-24 w-auto" alt="Tper elearning" />
    <div class="p-4">
      <p class="text-2xl">Non si dispone dei permessi necessari per visualizzare questa pagina.</p>
      <div *ngIf="token" class="mt-8 flex justify-end">
        <a (click)="goBack()" class="flex cursor-pointer items-center text-xl">
          <svg class="mr-2 h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
          </svg>
          Torna indietro
        </a>
      </div>
    </div>
  </div>
</div>
